import angular from 'angular'
import moment from 'moment'
import Fuse from 'fuse.js'
import importTableDirective from './import_table'
import licenseFormDirective from './license_form'
import _ from 'lodash'
import diffAttributeComponent from './diff_attribute'
import Vue from 'vue'
import AutoprovisioningDashboard from '../../partials/import_wizard/AutoprovisioningDashboard.vue'
export default angular
  .module('adminPanel.directives', ['ngVue'])
  .component('diffAttribute', diffAttributeComponent)
  .directive('importTable', importTableDirective)
  .directive('licenseForm', licenseFormDirective)
  .directive('googleSignIn', function() {
    let redirectTo = ''
    /* TODO Need to fix this for prod
    let redirectTo = '?redirectTo=' + encodeURIComponent(window.location.href)
        if (process.env.NODE_ENV === 'development') {
          redirectTo = ''
        }
    */
    return {
      restrict: 'E',
      scope: {
        config: '='
      },
      link: function(scope, elm) {
        google.accounts.id.initialize({
          client_id: scope.config.googleClientId,
          login_uri: scope.config.root + 'auth/verify_google' + redirectTo,
          ux_mode: 'redirect',
          auto_select: false,
          cancel_on_tap_outside: true,
          hd: 'goalbook.com'
        })

        google.accounts.id.renderButton(elm[0], { theme: 'filled_blue', size: 'large' })
      }
    }
  })
  .directive('modalAlert', [
    '$uibModal',
    function($modal) {
      return {
        restrict: 'EA',
        scope: true,
        link: function(scope, elm, attrs) {
          scope.$watch(attrs.message, function(msg) {
            scope.message = msg
          })
          scope.$watch(attrs.title, function(title) {
            scope.title = title
          })
          var modalInstance
          var open = function() {
            modalInstance = $modal.open({
              scope: scope,
              template:
                '' +
                '<div class="modal-header"><a class="close" ng-click="ctrl.close()">&times;</a>{{title}}</div>' +
                '<div class="modal-body">' +
                '<p>{{message}}</p>' +
                '</div>',
              controller: [
                '$uibModalInstance',
                function($modalInstance) {
                  this.close = function() {
                    $modalInstance.close()
                  }
                }
              ],
              controllerAs: 'ctrl'
            })
            modalInstance.result.then(function() {
              scope.show = false
              scope.$parent.$eval(attrs.modalAlert + '=' + 'false')
            })
          }

          scope.$watch(attrs.modalAlert, function(newShow) {
            if (newShow) {
              open()
            }
          })
        }
      }
    }
  ])
  .directive('userListDiff', function() {
    return {
      restrict: 'EA',
      template: require('./../../partials/import_wizard/_userListDiff.html'),
      scope: {
        users: '=',
        linkUsers: '=',
        tableId: '@'
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.diffEmpty = function(diffAttr) {
            if (!diffAttr) {
              return true
            }
            return (
              (!diffAttr.old || diffAttr.old === '' || diffAttr.old.length === 0) &&
              (!diffAttr.new || diffAttr.new === '' || diffAttr.new.length === 0)
            )
          }
        }
      ]
    }
  })
  .directive('schoolListDiff', function() {
    return {
      restrict: 'EA',
      template: require('./../../partials/import_wizard/_schoolListDiff.html'),
      scope: {
        schools: '=',
        tableId: '@',
        oldSchools: '='
      },
      controller: [
        '$scope',
        'adminApi',
        '$state',
        function($scope, adminApi, $state) {
          var searchList = new Fuse($scope.oldSchools)
          $scope.$watchCollection('oldSchools', function() {
            searchList = new Fuse($scope.oldSchools)
          })
          $scope.setClosestMatch = function(school) {
            var result = searchList.search(school)
            if (result.length > 0) {
              $scope.schoolsToOverwrite[school] = result[0].item
            } else {
              alert('No match found!')
            }
          }
          $scope.schoolsToOverwrite = {}
          $scope.$watchCollection('schoolsToOverwrite', function() {
            for (var key in $scope.schoolsToOverwrite) {
              if (!$scope.schoolsToOverwrite[key]) {
                delete $scope.schoolsToOverwrite[key]
              }
            }
          })
          $scope.$on('ReuploadWithChanges', function(evt, importUuid, domainUuid) {
            if ($scope.oldSchools) {
              var changesPresent = Object.keys($scope.schoolsToOverwrite).length > 0
              if (!changesPresent) {
                alert('There are no changes to re-upload!')
              } else {
                adminApi
                  .updateSchoolsForUserData(importUuid, $scope.schoolsToOverwrite)
                  .then(function() {
                    $state.go('import-wizard.import-status', {
                      domainUuid: domainUuid,
                      importUuid: importUuid
                    })
                  })
              }
            }
          })
          $scope.$on('MoveToLicenses', function(evt, importUuid, domainUuid) {
            if ($scope.oldSchools && Object.keys($scope.schoolsToOverwrite).length > 0) {
              var moveForward = confirm(
                'There are changes ready for re-upload. If you move to licenses, these changes will be lost. Are you sure you want to proceed?'
              )
              if (!moveForward) {
                return
              }
            }
            $state.go('import-wizard.step4', { domainUuid: domainUuid, importUuid: importUuid })
          })
        }
      ]
    }
  })
  .directive('userLicenseList', function() {
    return {
      restrict: 'EA',
      template: require('./../../partials/import_wizard/_userLicenseList.html'),
      scope: {
        licenses: '=',
        licenseMap: '=',
        editMode: '=',
        tableId: '@'
      }
    }
  })
  .directive('userDiff', function() {
    return {
      restruct: 'EA',
      template:
        '' +
        `<div class="alert alert-danger" ng-if="ctrl.userDiffError">
        {{ctrl.userDiffError}}
      </div>
      <h4 class="thead-heading">{{ctrl.userDiff.new.length}} New (to be created) – <a ng-click="ctrl.showNew = !ctrl.showNew">{{ctrl.showNew && 'Hide' || 'Show'}}</a></h4>
      <div uib-collapse="!ctrl.showNew" user-list-diff users="ctrl.userDiff.new" link-users="ctrl.linkUsers" table-id="new-users-table"></div>
      <h4 class="thead-heading">{{ctrl.userDiff.edited.length}} Edited – <a ng-click="ctrl.showEdited = !ctrl.showEdited">{{ctrl.showEdited && 'Hide' || 'Show'}}</a></h4>
      <div uib-collapse="!ctrl.showEdited" user-list-diff users="ctrl.userDiff.edited" link-users="ctrl.linkUsers" table-id="edited-users-table"></div>
      <h4 class="thead-heading">{{ctrl.userDiff.unchanged.length}} Unchanged – <a ng-click="ctrl.showUnchanged = !ctrl.showUnchanged">{{ctrl.showUnchanged && 'Hide' || 'Show'}}</a></h4>
      <div uib-collapse="!ctrl.showUnchanged" user-list-diff users="ctrl.userDiff.unchanged" link-users="ctrl.linkUsers" table-id="unchanged-users-table"></div>
      <h4 ng-if="ctrl.showUsersToDeactivateTable" class="thead-heading">{{ctrl.userDiff.deactivating.length}} Users To Deactivate - <b class="text-danger">THESE USERS WILL LOSE ACTIVE ENTERPRISE ACCESS TO TOOLKIT</b> – <a ng-click="ctrl.showUsersToDeactivate = !ctrl.showUsersToDeactivate">{{ctrl.showUsersToDeactivate && 'Hide' || 'Show'}}</a></h4>
      <div ng-if="ctrl.showUsersToDeactivateTable" uib-collapse="!ctrl.showUsersToDeactivate" user-list-diff users="ctrl.userDiff.deactivating" link-users="ctrl.linkUsers" table-id="deactivating-users-table"></div>
      <div ng-if="ctrl.isReplaceAllImport && ctrl.showUsersToDeactivateTable && !!ctrl.totalUsersToBeAdded" class="alert alert-warning lead"><i class="fa fa-warning"></i> After import, this domain will have {{ctrl.totalUsersToBeAdded}} active users</div>`,
      scope: {
        importUuid: '@',
        domain: '@',
        linkUsers: '=',
        isReplaceAllImport: '=',
        diffFetching: '&onLoadDiffStarted',
        diffLoaded: '&onLoadDiffFinished',
        diffError: '&onLoadDiffError'
      },
      controllerAs: 'ctrl',
      controller: [
        '$scope',
        'adminApi',
        function($scope, adminApi) {
          var _self = this
          _self.showNew = true
          _self.showEdited = true
          _self.userDiff = {}
          _self.linkUsers = $scope.linkUsers
          _self.isReplaceAllImport = $scope.isReplaceAllImport
          _self.totalUsersToBeAdded = 0
          var importUuid = $scope.importUuid
          var diffLoaded = $scope.diffLoaded
          var diffFetching = $scope.diffFetching
          var diffError = $scope.diffError

          _self.getDiff = function() {
            if (importUuid) {
              _self.loading = true
              diffFetching()
              adminApi.getUserDiff(importUuid).then(function(result) {
                if (result.status === 'error') {
                  _self.userDiffError = result.message
                  diffError({ error: result.message })
                } else {
                  if (result.users_to_deactivate_details.length > 0) {
                    _self.showUsersToDeactivate = true
                    _self.showUsersToDeactivateTable = true
                    result.diff_users.deactivating = result.users_to_deactivate_details.map(
                      function(user) {
                        return {
                          name: {
                            new: user.name,
                            old: user.name
                          },
                          email: {
                            new: user.email,
                            old: user.email
                          },
                          title: {
                            new: user.title,
                            old: user.title
                          },
                          tags: {
                            new: user.tags,
                            old: user.tags
                          },
                          sso_external_id: {
                            new: user.sso_external_id,
                            old: user.sso_external_id
                          },
                          domain_name: {
                            new: $scope.domain,
                            old: $scope.domain
                          },
                          uuid: user.uuid
                        }
                      }
                    )
                  }
                  _self.userDiff = result.diff_users
                  _self.totalUsersToBeAdded =
                    result.diff_users.new.length +
                    result.diff_users.edited.length +
                    result.diff_users.unchanged.length
                  diffLoaded({ userDiff: _self.userDiff })
                }
                _self.loading = false
              })
            }
          }

          // kick off
          _self.getDiff()
        }
      ]
    }
  })
  .directive('schoolDiff', function() {
    return {
      restruct: 'EA',
      template: `<div class="alert alert-danger" ng-if="ctrl.schoolDiffError">
        {{ctrl.schoolDiffError}}
      </div>
      <h4 class="thead-heading">{{ctrl.schoolDiff.new.length}} New (to be created) – <a ng-click="ctrl.showNew = !ctrl.showNew">{{ctrl.showNew && 'Hide' || 'Show'}}</a></h4>
      <div uib-collapse="!ctrl.showNew" school-list-diff schools="ctrl.schoolDiff.new" old-schools="ctrl.oldSchools" table-id="new-schools"></div>
      <h4 class="thead-heading">{{ctrl.schoolDiff.unchanged.length}} Existing – <a ng-click="ctrl.showExisting = !ctrl.showExisting">{{ctrl.showExisting && 'Hide' || 'Show'}}</a></h4>
      <div uib-collapse="!ctrl.showExisting" school-list-diff schools="ctrl.schoolDiff.unchanged" table-id="unchanged-schools"></div>
      <h4 class="thead-heading">{{ctrl.schoolDiff.unincluded.length}} Existing (not in CSV) – <a ng-click="ctrl.showUnincluded = !ctrl.showUnincluded">{{ctrl.showUnincluded && 'Hide' || 'Show'}}</a></h4>
      <div school-list-diff schools="ctrl.schoolDiff.unincluded" ng-if="ctrl.showUnincluded" table-id="unincluded-schools"></div>`,
      scope: {
        importUuid: '@',
        diffFetching: '&onLoadDiffStarted',
        diffLoaded: '&onLoadDiffFinished',
        diffError: '&onLoadDiffError'
      },
      controllerAs: 'ctrl',
      controller: [
        '$scope',
        'adminApi',
        function($scope, adminApi) {
          var _self = this
          _self.schoolDiff = {}
          _self.showNew = true
          var importUuid = $scope.importUuid
          var diffLoaded = $scope.diffLoaded
          var diffFetching = $scope.diffFetching
          var diffError = $scope.diffError
          _self.oldSchools = []

          _self.getDiff = function() {
            if (importUuid) {
              _self.loading = true
              diffFetching()
              adminApi.getSchoolDiff(importUuid).then(function(result) {
                if (result.status === 'error') {
                  _self.schoolDiffError = result.message
                  diffError({ error: result.message })
                } else {
                  _self.schoolDiff = result.diff_schools
                  _self.oldSchools = result.diff_schools.unincluded
                    .concat(result.diff_schools.unchanged)
                    .map(function(school) {
                      return school.name.old
                    })
                    .sort()
                  _self.oldSchools = [...new Set(_self.oldSchools)]
                  diffLoaded({ schoolDiff: _self.schoolDiff })
                }
                _self.loading = false
              })
            }
          }

          // kick off
          _self.getDiff()
        }
      ]
    }
  })
  .directive('licenseDiff', function() {
    return {
      restrict: 'EA',
      template:
        '' +
        '<div class="alert alert-danger" ng-if="ctrl.licenseDiffError">' +
        '{{ctrl.licenseDiffError}}' +
        '</div>' +
        '<div ng-if="editMode" class="well">' +
        '<div license-form template-license="ctrl.templateLicense"></div><button ng-click="ctrl.selectMatchingLicenses()" class="btn btn-sm btn-primary">Select {{ctrl.matchingLicenses.length}} matching licenses</button> <button class="btn btn-sm btn-default" ng-click="ctrl.deselectAllLicenses()">Deselect all</button>' +
        '</div>' +
        '<div user-license-list licenses="ctrl.importLicenseContent.new_licenses" license-map="ctrl.importLicenseContent.old_licenses" edit-mode="editMode" table-id="new-licenses-table"></div>',
      scope: {
        importUuid: '@',
        diffFetching: '&onLoadDiffStarted',
        diffLoaded: '&onLoadDiffFinished',
        diffError: '&onLoadDiffError',
        editMode: '='
      },
      controllerAs: 'ctrl',
      controller: [
        '$scope',
        'adminApi',
        function($scope, adminApi) {
          this.importLicenseContent = {}
          this.templateLicense = {
            product: null,
            type: null,
            sub_type: null,
            start_date_fmt: '',
            end_date_fmt: ''
          }
          var importUuid = $scope.importUuid
          var diffLoaded = $scope.diffLoaded
          var diffFetching = $scope.diffFetching
          var diffError = $scope.diffError

          this.getDiff = function() {
            if (importUuid) {
              this.loading = true
              diffFetching()
              adminApi.getActiveLicenses(importUuid).then(
                function(result) {
                  if (result.status === 'error') {
                    this.licenseDiffError = result.message
                    diffError({ error: result.message })
                  } else {
                    this.importLicenseContent = result
                    diffLoaded({ importLicenseContent: this.importLicenseContent })
                  }
                  this.loading = false
                }.bind(this)
              )
            }
          }

          var licenseMatchesTemplate = function(license) {
            var productMatch, typeMatch, subTypeMatch, startDateMatch, endDateMatch
            productMatch =
              (this.templateLicense.product && this.templateLicense.product === license.product) ||
              !this.templateLicense.product
            typeMatch =
              (this.templateLicense.type && this.templateLicense.type === license.type) ||
              !this.templateLicense.type
            subTypeMatch =
              (this.templateLicense.sub_type &&
                this.templateLicense.sub_type === license.sub_type) ||
              !this.templateLicense.sub_type
            startDateMatch =
              (this.templateLicense.start_date_fmt &&
                this.templateLicense.start_date_fmt === license.start_date_fmt) ||
              !this.templateLicense.start_date_fmt
            endDateMatch =
              (this.templateLicense.end_date_fmt &&
                this.templateLicense.end_date_fmt === license.end_date_fmt) ||
              !this.templateLicense.end_date_fmt

            return productMatch && typeMatch && subTypeMatch && startDateMatch && endDateMatch
          }.bind(this)

          // find licenses (new or old) that match the template license
          this.matchingLicenses = []
          this.getMatchingLicenses = function() {
            this.matchingLicenses = []
            // if (!this.templateLicense.product || !this.templateLicense.type || !this.templateLicense.sub_type) {
            //   alert('Template license must have product, type, and sub type specified');
            //   return;
            // }
            if (this.importLicenseContent.new_licenses) {
              this.importLicenseContent.new_licenses.forEach(
                function(nl) {
                  if (licenseMatchesTemplate(nl)) {
                    this.matchingLicenses.push(nl)
                  }
                }.bind(this)
              )
            }

            if (this.importLicenseContent.old_licenses) {
              Object.keys(this.importLicenseContent.old_licenses).forEach(
                function(uuid) {
                  var userOldLicenses = this.importLicenseContent.old_licenses[uuid]
                  userOldLicenses.forEach(
                    function(ol) {
                      if (licenseMatchesTemplate(ol)) {
                        this.matchingLicenses.push(ol)
                      }
                    }.bind(this)
                  )
                }.bind(this)
              )
            }
            return this.matchingLicenses
          }
          this.selectMatchingLicenses = function() {
            this.matchingLicenses.forEach(function(l) {
              l.delete = true
            })
          }
          this.deselectAllLicenses = function() {
            if (this.importLicenseContent.new_licenses) {
              this.importLicenseContent.new_licenses.forEach(function(nl) {
                nl.delete = false
              })
            }

            if (this.importLicenseContent.old_licenses) {
              Object.keys(this.importLicenseContent.old_licenses).forEach(
                function(uuid) {
                  var userOldLicenses = this.importLicenseContent.old_licenses[uuid]
                  userOldLicenses.forEach(function(ol) {
                    ol.delete = false
                  })
                }.bind(this)
              )
            }
          }
          $scope.$watchCollection(
            'ctrl.templateLicense',
            function() {
              this.getMatchingLicenses()
            }.bind(this)
          )

          // kick off
          this.getDiff()
        }
      ]
    }
  })
  .directive('navbarUserSearch', [
    '$q',
    function($q) {
      return {
        restrict: 'EA',
        template: require('./../../partials/_navbarUserSearch.html'),
        scope: {
          submit: '&onSubmit'
        },
        controller: [
          'search',
          '$scope',
          '$state',
          function(search, $scope, $state) {
            $scope.submit = function(email) {
              $state.go('user-info', { email: email.email })
            }
            $scope.autocompleteResults = []
            $scope.searchDelay = 400 //milliseconds
            var oldInput
            var numResults = 8
            $scope.searchDB = function() {
              var deferred = $q.defer()
              search.searchUsers('', $scope.input, '', numResults).then(
                function(data) {
                  data = JSON.parse(data)
                  console.dir(data)
                  $scope.autocompleteResults = data.hits.hits.map(function(hit) {
                    return {
                      value: hit._source.email,
                      type: 'User'
                    }
                  })
                  search.searchDomains($scope.input, numResults).then(
                    function(data) {
                      data = JSON.parse(data)
                      console.dir(data)
                      var domainResults = data.hits.hits.map(function(hit) {
                        return {
                          value: hit._source.n,
                          type: 'Domain',
                          uuid: hit._source.i
                        }
                      })
                      $scope.autocompleteResults = $scope.autocompleteResults.concat(domainResults)
                      if ($scope.autocompleteResults.length === 0) {
                        $scope.autocompleteResults = [
                          {
                            value: 'No results found',
                            type: ':('
                          }
                        ]
                      }
                      oldInput = $scope.input
                      deferred.resolve($scope.autocompleteResults)
                    },
                    function(err) {
                      console.log(err)
                      deferred.reject(err)
                    }
                  )
                },
                function(err) {
                  console.log(err)
                  deferred.reject(err)
                }
              )
              return deferred.promise
            }
            $scope.goToPage = function(ind, model) {
              console.dir(model)
              if (model.type === 'User') {
                $state.go('user-info', { email: model.value })
              } else if (model.type === 'Domain') {
                $state.go('domain-detail', { uuid: model.uuid })
              } else if (model.type === ':(') {
                $scope.input = oldInput
                return
              }
              $scope.input = model.value
            }
          }
        ]
      }
    }
  ])
  .directive('selectUsers', [
    'licenseTypes',
    'tagValues',
    'validators',
    function(licenseTypes, tagValues, validators) {
      return {
        restrict: 'EA',
        template: require('./../../partials/import_wizard/_selectUsers.html'),
        scope: {
          done: '&onDone',
          domainUuid: '@'
        },
        controllerAs: 'ctrl',
        controller: [
          'adminApi',
          'graph',
          '$scope',
          function(adminApi, graph, $scope) {
            var self = this
            self.users = [] // array of user info objects
            self.importDataArray = [] // array of import CSV rows
            self.licenseTypes = licenseTypes
            self.tagValues = tagValues
            self.newLicense = {
              start_date: moment(new Date()).format('YYYY-MM-DD')
            }
            self.showNewLicense = true
            self.domainUuid = $scope.domainUuid

            var csvHeaders = {
              NAME: 'Name',
              TITLE: 'Title',
              EMAIL: 'Email',
              PASSWORD: 'Password',
              SCHOOL: 'School',
              PRODUCT: 'Product',
              TYPE: 'Type',
              SUB_TYPE: 'Sub Type',
              START_DATE: 'Start Date',
              END_DATE: 'End Date',
              TAG: 'Tag'
            }
            self.orderedHeaders = [
              csvHeaders.NAME,
              csvHeaders.TITLE,
              csvHeaders.EMAIL,
              csvHeaders.PASSWORD,
              csvHeaders.SCHOOL,
              csvHeaders.PRODUCT,
              csvHeaders.TYPE,
              csvHeaders.SUB_TYPE,
              csvHeaders.START_DATE,
              csvHeaders.END_DATE,
              csvHeaders.TAG
            ]
            self.csvHeaders = csvHeaders

            self.domainSchools = []
            graph.getDomainSchools($scope.domainUuid).then(
              function(data) {
                self.domainSchools = data
              },
              function(errData) {
                console.log(errData)
                alert(errData.message)
              }
            )

            self.domainUserEmails = []
            if ($scope.domainUuid) {
              // if blank, then this is a consumer domain import
              graph.getDomainUsers($scope.domainUuid).then(
                function(data) {
                  self.domainUserEmails = data.map(function(u) {
                    return u.email
                  })
                },
                function(errData) {
                  console.log(errData)
                  alert(errData.message)
                }
              )
            }

            function userInfoToCSVRow(userInfo) {
              var row = {}
              row[csvHeaders.NAME] = userInfo.user_account.name
              row[csvHeaders.TITLE] = userInfo.user_account.title
              row[csvHeaders.EMAIL] = userInfo.user_account.email
              row[csvHeaders.PASSWORD] = userInfo.new_password || null
              row[csvHeaders.SCHOOL] = userInfo.new_school_name
              row[csvHeaders.PRODUCT] = userInfo.new_license_product || null
              row[csvHeaders.TYPE] = userInfo.new_license_type || null
              row[csvHeaders.SUB_TYPE] = userInfo.new_license_sub_type || null
              row[csvHeaders.START_DATE] = userInfo.new_license_start_date || null
              row[csvHeaders.END_DATE] = userInfo.new_license_end_date || null
              row[csvHeaders.TAG] = userInfo.tag || null
              return row
            }

            function validateUsersInSameDomain(users) {
              if (users.length > 0) {
                var domainUuid =
                  (users[0].domains && users[0].domains[0] && users[0].domains[0].uuid) || '' // '' means consumer domain
                for (var i = 1; i < users.length; i++) {
                  if (users[i].newUser) {
                    continue
                  }
                  var d =
                    (users[i].domains && users[i].domains[0] && users[i].domains[0].uuid) || ''
                  if (domainUuid !== d) return false
                }
                return domainUuid
              }
              return false
            }

            function usersToCSVData(users) {
              return _.map(users, userInfoToCSVRow)
            }

            var addUser = function(userInfo) {
              // check if already in the list
              console.log(userInfo)
              if (
                self.users.some(function(u) {
                  return u.user_graph.email && u.user_graph.email === userInfo.user_graph.email
                })
              ) {
                alert('User ' + userInfo.user_graph.email + ' already added')
              } else {
                self.users.push(userInfo)
              }
            }

            self.fetchUser = function(email) {
              return adminApi.getUserInfo(email).then(
                function(info) {
                  addUser(info)
                  info.new_school_name =
                    (info.schools && info.schools[0] && info.schools[0].name) || null
                },
                function(reason) {
                  alert('Error fetching info for ' + email)
                  console.log(reason)
                }
              )
            }

            self.batchFetchUsers = function(pastedEmails) {
              // pastedEmails is expected to be a new-line delimited list of emails
              var emails = pastedEmails.split('\n').filter(function(e) {
                return e && e.length > 0
              })
              var counter = 0
              self.fetchingBatchUsers = true
              emails.forEach(function(email) {
                self.fetchUser(email).then(function() {
                  if (++counter === emails.length) {
                    self.fetchingBatchUsers = false
                  }
                })
              })
            }

            self.createEmptyUser = function() {
              addUser({
                user_account: {},
                user_graph: {},
                domains: [{ uuid: self.domainUuid }],
                new_license_start_date: moment(new Date()).format('YYYY-MM-DD')
              })
            }

            self.editAttribute = function(user, attrName) {
              var shouldPrompt = true
              while (shouldPrompt) {
                var newVal = prompt('Enter a value for ' + attrName, user[attrName])
                var validator = self.attributeValidators[attrName]

                if (newVal) {
                  var result = { OK: true }
                  if (validator) {
                    var result = validator(newVal)
                  }

                  if (result.OK) {
                    user[attrName] = newVal
                    shouldPrompt = false
                  } else {
                    alert(result.message)
                  }
                } else if (newVal == '') {
                  user[attrName] = newVal
                  shouldPrompt = false
                } else {
                  shouldPrompt = false
                }
              }
            }

            self.attributeValidators = {
              new_license_start_date: validators.validateLicenseStartDate
            }

            self.applyTag = function() {
              _.each(self.users, function(u) {
                u.tag = self.newTag
              })
            }

            self.applyNewLicense = function() {
              var result = validators.validateLicenseStartDate(self.newLicense.start_date)
              if (!result.OK) {
                self.errorMessage = result.message
              }

              _.each(self.users, function(u) {
                var cl = angular.copy(self.newLicense)
                u.new_license_product = cl.product
                u.new_license_type = cl.type
                u.new_license_sub_type = cl.sub_type
                u.new_license_start_date = cl.start_date
                u.new_license_end_date = cl.end_date
              })
            }

            self.convertToCSVRows = function() {
              self.importDataArray = usersToCSVData(self.users)
            }

            self.removeUser = function(index) {
              self.users.splice(index, 1)
            }

            self.clearSelectedUsers = function() {
              if (confirm('Are you sure you want to clear the list?')) {
                self.users = []
              }
            }

            self.submit = function() {
              self.convertToCSVRows()
              $scope.done({
                csvData: self.importDataArray,
                domainUuid: validateUsersInSameDomain(self.users)
              })
            }
          }
        ]
      }
    }
  ])
  .directive('selectDomainTypeAhead', [
    'graph',
    function(graph) {
      return {
        restrict: 'EA',
        scope: {
          onSelectDomain: '&onSelectDomain'
        },
        link: function(scope, elm, attrs) {
          scope.allDomains = []
          graph.getDomains().then(function(res) {
            if (res.status === 'error') {
              alert(res.message)
            } else if (angular.isArray(res)) {
              scope.allDomains = res
            }
          })
        },
        template:
          '<input type="text" class="form-control" uib-typeahead="domain as domain.name for domain in allDomains | filter:$viewValue | limitTo:10" ng-model="selectedDomain" typeahead-min-length="2" typeahead-on-select="onSelectDomain({domain: $item})" placeholder="domain name">'
      }
    }
  ])
  .directive('autoprovisioningTab', ['adminApi', function(adminApi) {
    return {
      restrict: 'E',
      scope: {},
      link: function(scope, element) {
        const app = new Vue({
          el: element[0],
          provide: {
            adminApi: adminApi,
            angularScope: scope.$parent
          },
          render: h => h(AutoprovisioningDashboard)
        })
        scope.$on('$destroy', function() {
          app.$destroy()
        })
      }
    }
  }])
